<template functional>
  <span v-if="$options.methods.isValuePresent(props.value1) || $options.methods.isValuePresent(props.value2) || !props.hideIfNoData">
    <strong v-if="props.title">{{ props.title }}</strong>
    <span v-if="$options.methods.isValuePresent(props.value1) || $options.methods.isValuePresent(props.value2)">
      <component :is="$options.components.BuildingDimensionLabel" :value="props.value1" />
      <span v-if="$options.methods.isValuePresent(props.value2)">
        {{ props.separator }} <component :is="$options.components.BuildingDimensionLabel" :value="props.value2" />
      </span>
    </span>
    <span v-else-if="props.hideIfNoData" />
    <component :is="$options.components.Label" v-else />
  </span>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

import Label from '@/bundles/Common/components/Label.vue';

import BuildingDimensionLabel from './BuildingDimensionLabel.vue';

export default Vue.extend({
  name: 'BuildingDimensionLabels',

  components: {
    Label,
    BuildingDimensionLabel
  },

  props: {
    title: {
      type: String,
      default: null
    },
    value1: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null
    },
    value2: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null
    },
    separator: {
      type: String,
      default: '-'
    },
    hideIfNoData: Boolean
  },

  methods: {
    isValuePresent
  }
});
</script>
